
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class PageMissing extends Vue {
    private returnHome() {
        this.$router.replace('/');
    }
}
